/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  TestCaseCreate,
  TestCaseOutputRead,
  TestCaseRead,
  TestCaseUpdate,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    TestCaseCreateFromJSON,
    TestCaseCreateToJSON,
    TestCaseOutputReadFromJSON,
    TestCaseOutputReadToJSON,
    TestCaseReadFromJSON,
    TestCaseReadToJSON,
    TestCaseUpdateFromJSON,
    TestCaseUpdateToJSON,
} from '../models/index';

export interface CreateTestCaseRequest {
    testCaseCreate: TestCaseCreate;
}

export interface CreateTestCasesRequest {
    testCaseCreate: Array<TestCaseCreate>;
}

export interface DeleteTestCaseRequest {
    testCaseId: string;
}

export interface GetTestCaseRequest {
    testCaseId: string;
}

export interface GetTestCasesRequest {
    problemId?: string | null;
}

export interface PreviewTestCaseRequest {
    testCaseId: string;
}

export interface UpdateTestCaseRequest {
    testCaseId: string;
    testCaseUpdate: TestCaseUpdate;
}

/**
 * 
 */
export class TestCasesApi extends runtime.BaseAPI {

    /**
     * Create a new test case.  **Authorization:** User must be able to modify the problem (owner, admin, content creator, or competition organizer).  Args:     test_case: Test case data to create     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Created test case  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user cannot modify the problem     HTTPException: 404 if problem not found
     * Create Test Case
     */
    async createTestCaseRaw(requestParameters: CreateTestCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TestCaseRead>> {
        if (requestParameters['testCaseCreate'] == null) {
            throw new runtime.RequiredError(
                'testCaseCreate',
                'Required parameter "testCaseCreate" was null or undefined when calling createTestCase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/test_cases/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TestCaseCreateToJSON(requestParameters['testCaseCreate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TestCaseReadFromJSON(jsonValue));
    }

    /**
     * Create a new test case.  **Authorization:** User must be able to modify the problem (owner, admin, content creator, or competition organizer).  Args:     test_case: Test case data to create     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Created test case  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user cannot modify the problem     HTTPException: 404 if problem not found
     * Create Test Case
     */
    async createTestCase(requestParameters: CreateTestCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TestCaseRead> {
        const response = await this.createTestCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create multiple test cases in a batch.  **Authorization:** User must be able to modify all referenced problems.  Args:     test_cases: List of test case data to create     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     List of created test cases  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user cannot modify any of the problems     HTTPException: 404 if any problem not found
     * Create Test Cases
     */
    async createTestCasesRaw(requestParameters: CreateTestCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TestCaseRead>>> {
        if (requestParameters['testCaseCreate'] == null) {
            throw new runtime.RequiredError(
                'testCaseCreate',
                'Required parameter "testCaseCreate" was null or undefined when calling createTestCases().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/test_cases/batch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['testCaseCreate']!.map(TestCaseCreateToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TestCaseReadFromJSON));
    }

    /**
     * Create multiple test cases in a batch.  **Authorization:** User must be able to modify all referenced problems.  Args:     test_cases: List of test case data to create     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     List of created test cases  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user cannot modify any of the problems     HTTPException: 404 if any problem not found
     * Create Test Cases
     */
    async createTestCases(requestParameters: CreateTestCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TestCaseRead>> {
        const response = await this.createTestCasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a test case.  **Authorization:** User must be able to modify the problem.  Args:     test_case_id: ID of test case to delete     session: Database session (injected)     current_user: Currently authenticated user (injected)  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user cannot modify the problem     HTTPException: 404 if test case not found
     * Delete Test Case
     */
    async deleteTestCaseRaw(requestParameters: DeleteTestCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['testCaseId'] == null) {
            throw new runtime.RequiredError(
                'testCaseId',
                'Required parameter "testCaseId" was null or undefined when calling deleteTestCase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/test_cases/{test_case_id}`.replace(`{${"test_case_id"}}`, encodeURIComponent(String(requestParameters['testCaseId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a test case.  **Authorization:** User must be able to modify the problem.  Args:     test_case_id: ID of test case to delete     session: Database session (injected)     current_user: Currently authenticated user (injected)  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user cannot modify the problem     HTTPException: 404 if test case not found
     * Delete Test Case
     */
    async deleteTestCase(requestParameters: DeleteTestCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTestCaseRaw(requestParameters, initOverrides);
    }

    /**
     * Get a single test case by ID.  **Authorization:** User must have access to the problem.  Args:     test_case_id: ID of test case to retrieve     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Test case  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user cannot access     HTTPException: 404 if test case not found
     * Get Test Case
     */
    async getTestCaseRaw(requestParameters: GetTestCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TestCaseRead>> {
        if (requestParameters['testCaseId'] == null) {
            throw new runtime.RequiredError(
                'testCaseId',
                'Required parameter "testCaseId" was null or undefined when calling getTestCase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/test_cases/{test_case_id}`.replace(`{${"test_case_id"}}`, encodeURIComponent(String(requestParameters['testCaseId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TestCaseReadFromJSON(jsonValue));
    }

    /**
     * Get a single test case by ID.  **Authorization:** User must have access to the problem.  Args:     test_case_id: ID of test case to retrieve     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Test case  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user cannot access     HTTPException: 404 if test case not found
     * Get Test Case
     */
    async getTestCase(requestParameters: GetTestCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TestCaseRead> {
        const response = await this.getTestCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all test cases, optionally filtered by problem.  **Authorization:** User must have access to the problem to view its test cases.  Args:     session: Database session (injected)     current_user: Currently authenticated user (injected)     problem_id: Optional problem ID to filter by  Returns:     List of test cases  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user cannot access the problem\'s test cases
     * Get Test Cases
     */
    async getTestCasesRaw(requestParameters: GetTestCasesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TestCaseRead>>> {
        const queryParameters: any = {};

        if (requestParameters['problemId'] != null) {
            queryParameters['problem_id'] = requestParameters['problemId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/test_cases/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TestCaseReadFromJSON));
    }

    /**
     * Get all test cases, optionally filtered by problem.  **Authorization:** User must have access to the problem to view its test cases.  Args:     session: Database session (injected)     current_user: Currently authenticated user (injected)     problem_id: Optional problem ID to filter by  Returns:     List of test cases  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user cannot access the problem\'s test cases
     * Get Test Cases
     */
    async getTestCases(requestParameters: GetTestCasesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TestCaseRead>> {
        const response = await this.getTestCasesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the official output preview for a test case.  **Authorization:** User must have access to the problem.  Args:     test_case_id: ID of test case     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Test case official output or None if not available  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user cannot access     HTTPException: 404 if test case not found
     * Preview Test Case
     */
    async previewTestCaseRaw(requestParameters: PreviewTestCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TestCaseOutputRead>> {
        if (requestParameters['testCaseId'] == null) {
            throw new runtime.RequiredError(
                'testCaseId',
                'Required parameter "testCaseId" was null or undefined when calling previewTestCase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/test_cases/{test_case_id}/preview`.replace(`{${"test_case_id"}}`, encodeURIComponent(String(requestParameters['testCaseId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TestCaseOutputReadFromJSON(jsonValue));
    }

    /**
     * Get the official output preview for a test case.  **Authorization:** User must have access to the problem.  Args:     test_case_id: ID of test case     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Test case official output or None if not available  Raises:     HTTPException: 401 if user not authenticated     HTTPException: 403 if user cannot access     HTTPException: 404 if test case not found
     * Preview Test Case
     */
    async previewTestCase(requestParameters: PreviewTestCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TestCaseOutputRead> {
        const response = await this.previewTestCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing test case.  **Authorization:** User must be able to modify the problem.  The body carries `id`, `driver_code`, `points` and `visibility`; only those change. The problem, `status` and `official_output_id` belong to the server, and a request that sends them changes nothing.  Changing `driver_code` resets the test case\'s preparation: the status goes back to `new` and the official output with its accepted variants is deleted, so the problem has to be prepared again. Changing only `points` keeps the preparation and gives the outputs the new points; results judged before keep theirs until they are judged again.  Args:     test_case_id: ID of test case to update     test_case_update: Updated test case data     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Updated test case  Raises:     HTTPException: 400 if ID mismatch     HTTPException: 401 if user not authenticated     HTTPException: 403 if user cannot modify the problem     HTTPException: 404 if test case not found
     * Update Test Case
     */
    async updateTestCaseRaw(requestParameters: UpdateTestCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TestCaseRead>> {
        if (requestParameters['testCaseId'] == null) {
            throw new runtime.RequiredError(
                'testCaseId',
                'Required parameter "testCaseId" was null or undefined when calling updateTestCase().'
            );
        }

        if (requestParameters['testCaseUpdate'] == null) {
            throw new runtime.RequiredError(
                'testCaseUpdate',
                'Required parameter "testCaseUpdate" was null or undefined when calling updateTestCase().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/judge/test_cases/{test_case_id}`.replace(`{${"test_case_id"}}`, encodeURIComponent(String(requestParameters['testCaseId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: TestCaseUpdateToJSON(requestParameters['testCaseUpdate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TestCaseReadFromJSON(jsonValue));
    }

    /**
     * Update an existing test case.  **Authorization:** User must be able to modify the problem.  The body carries `id`, `driver_code`, `points` and `visibility`; only those change. The problem, `status` and `official_output_id` belong to the server, and a request that sends them changes nothing.  Changing `driver_code` resets the test case\'s preparation: the status goes back to `new` and the official output with its accepted variants is deleted, so the problem has to be prepared again. Changing only `points` keeps the preparation and gives the outputs the new points; results judged before keep theirs until they are judged again.  Args:     test_case_id: ID of test case to update     test_case_update: Updated test case data     session: Database session (injected)     current_user: Currently authenticated user (injected)  Returns:     Updated test case  Raises:     HTTPException: 400 if ID mismatch     HTTPException: 401 if user not authenticated     HTTPException: 403 if user cannot modify the problem     HTTPException: 404 if test case not found
     * Update Test Case
     */
    async updateTestCase(requestParameters: UpdateTestCaseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TestCaseRead> {
        const response = await this.updateTestCaseRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
